import * as X from "react";
import Wr, { forwardRef as zr, useContext as xt } from "react";
import { keyframes as Ct, css as ge } from "@emotion/react";
import { getColor as Tt, applyBoxStyle as Ot, deleteCssProps as Pt } from "@illa-design/theme";
var rr = { exports: {} }, me = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tr;
function Nt() {
  if (Tr)
    return me;
  Tr = 1;
  var e = Wr, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(l, v, m) {
    var d, y = {}, $ = null, k = null;
    m !== void 0 && ($ = "" + m), v.key !== void 0 && ($ = "" + v.key), v.ref !== void 0 && (k = v.ref);
    for (d in v)
      a.call(v, d) && !s.hasOwnProperty(d) && (y[d] = v[d]);
    if (l && l.defaultProps)
      for (d in v = l.defaultProps, v)
        y[d] === void 0 && (y[d] = v[d]);
    return { $$typeof: r, type: l, key: $, ref: k, props: y, _owner: o.current };
  }
  return me.Fragment = n, me.jsx = f, me.jsxs = f, me;
}
var ye = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Or;
function At() {
  return Or || (Or = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Wr, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), l = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), $ = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), N = Symbol.iterator, b = "@@iterator";
    function M(t) {
      if (t === null || typeof t != "object")
        return null;
      var i = N && t[N] || t[b];
      return typeof i == "function" ? i : null;
    }
    var S = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(t) {
      {
        for (var i = arguments.length, u = new Array(i > 1 ? i - 1 : 0), h = 1; h < i; h++)
          u[h - 1] = arguments[h];
        P("error", t, u);
      }
    }
    function P(t, i, u) {
      {
        var h = S.ReactDebugCurrentFrame, R = h.getStackAddendum();
        R !== "" && (i += "%s", u = u.concat([R]));
        var A = u.map(function(_) {
          return String(_);
        });
        A.unshift("Warning: " + i), Function.prototype.apply.call(console[t], console, A);
      }
    }
    var I = !1, c = !1, L = !1, O = !1, ze = !1, we;
    we = Symbol.for("react.module.reference");
    function Ue(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === s || ze || t === o || t === m || t === d || O || t === k || I || c || L || typeof t == "object" && t !== null && (t.$$typeof === $ || t.$$typeof === y || t.$$typeof === f || t.$$typeof === l || t.$$typeof === v || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === we || t.getModuleId !== void 0));
    }
    function qe(t, i, u) {
      var h = t.displayName;
      if (h)
        return h;
      var R = i.displayName || i.name || "";
      return R !== "" ? u + "(" + R + ")" : u;
    }
    function xe(t) {
      return t.displayName || "Context";
    }
    function B(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case s:
          return "Profiler";
        case o:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var i = t;
            return xe(i) + ".Consumer";
          case f:
            var u = t;
            return xe(u._context) + ".Provider";
          case v:
            return qe(t, t.render, "ForwardRef");
          case y:
            var h = t.displayName || null;
            return h !== null ? h : B(t.type) || "Memo";
          case $: {
            var R = t, A = R._payload, _ = R._init;
            try {
              return B(_(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, Q = 0, Ce, Te, ue, Oe, fe, Pe, Ne;
    function Ae() {
    }
    Ae.__reactDisabledLog = !0;
    function Be() {
      {
        if (Q === 0) {
          Ce = console.log, Te = console.info, ue = console.warn, Oe = console.error, fe = console.group, Pe = console.groupCollapsed, Ne = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Ae,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Q++;
      }
    }
    function Ge() {
      {
        if (Q--, Q === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: Ce
            }),
            info: H({}, t, {
              value: Te
            }),
            warn: H({}, t, {
              value: ue
            }),
            error: H({}, t, {
              value: Oe
            }),
            group: H({}, t, {
              value: fe
            }),
            groupCollapsed: H({}, t, {
              value: Pe
            }),
            groupEnd: H({}, t, {
              value: Ne
            })
          });
        }
        Q < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var le = S.ReactCurrentDispatcher, de;
    function re(t, i, u) {
      {
        if (de === void 0)
          try {
            throw Error();
          } catch (R) {
            var h = R.stack.trim().match(/\n( *(at )?)/);
            de = h && h[1] || "";
          }
        return `
` + de + t;
      }
    }
    var pe = !1, te;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      te = new Je();
    }
    function p(t, i) {
      if (!t || pe)
        return "";
      {
        var u = te.get(t);
        if (u !== void 0)
          return u;
      }
      var h;
      pe = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = le.current, le.current = null, Be();
      try {
        if (i) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch (Z) {
              h = Z;
            }
            Reflect.construct(t, [], _);
          } else {
            try {
              _.call();
            } catch (Z) {
              h = Z;
            }
            t.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Z) {
            h = Z;
          }
          t();
        }
      } catch (Z) {
        if (Z && h && typeof Z.stack == "string") {
          for (var g = Z.stack.split(`
`), W = h.stack.split(`
`), D = g.length - 1, F = W.length - 1; D >= 1 && F >= 0 && g[D] !== W[F]; )
            F--;
          for (; D >= 1 && F >= 0; D--, F--)
            if (g[D] !== W[F]) {
              if (D !== 1 || F !== 1)
                do
                  if (D--, F--, F < 0 || g[D] !== W[F]) {
                    var q = `
` + g[D].replace(" at new ", " at ");
                    return t.displayName && q.includes("<anonymous>") && (q = q.replace("<anonymous>", t.displayName)), typeof t == "function" && te.set(t, q), q;
                  }
                while (D >= 1 && F >= 0);
              break;
            }
        }
      } finally {
        pe = !1, le.current = A, Ge(), Error.prepareStackTrace = R;
      }
      var oe = t ? t.displayName || t.name : "", Cr = oe ? re(oe) : "";
      return typeof t == "function" && te.set(t, Cr), Cr;
    }
    function ve(t, i, u) {
      return p(t, !1);
    }
    function ne(t) {
      var i = t.prototype;
      return !!(i && i.isReactComponent);
    }
    function ee(t, i, u) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return p(t, ne(t));
      if (typeof t == "string")
        return re(t);
      switch (t) {
        case m:
          return re("Suspense");
        case d:
          return re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case v:
            return ve(t.render);
          case y:
            return ee(t.type, i, u);
          case $: {
            var h = t, R = h._payload, A = h._init;
            try {
              return ee(A(R), i, u);
            } catch {
            }
          }
        }
      return "";
    }
    var $e = Object.prototype.hasOwnProperty, vr = {}, hr = S.ReactDebugCurrentFrame;
    function ke(t) {
      if (t) {
        var i = t._owner, u = ee(t.type, t._source, i ? i.type : null);
        hr.setExtraStackFrame(u);
      } else
        hr.setExtraStackFrame(null);
    }
    function ot(t, i, u, h, R) {
      {
        var A = Function.call.bind($e);
        for (var _ in t)
          if (A(t, _)) {
            var g = void 0;
            try {
              if (typeof t[_] != "function") {
                var W = Error((h || "React class") + ": " + u + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw W.name = "Invariant Violation", W;
              }
              g = t[_](i, _, h, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (D) {
              g = D;
            }
            g && !(g instanceof Error) && (ke(R), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", h || "React class", u, _, typeof g), ke(null)), g instanceof Error && !(g.message in vr) && (vr[g.message] = !0, ke(R), E("Failed %s type: %s", u, g.message), ke(null));
          }
      }
    }
    var it = Array.isArray;
    function Ke(t) {
      return it(t);
    }
    function st(t) {
      {
        var i = typeof Symbol == "function" && Symbol.toStringTag, u = i && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return u;
      }
    }
    function ct(t) {
      try {
        return mr(t), !1;
      } catch {
        return !0;
      }
    }
    function mr(t) {
      return "" + t;
    }
    function yr(t) {
      if (ct(t))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", st(t)), mr(t);
    }
    var he = S.ReactCurrentOwner, ut = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Er, gr, He;
    He = {};
    function ft(t) {
      if ($e.call(t, "ref")) {
        var i = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (i && i.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function lt(t) {
      if ($e.call(t, "key")) {
        var i = Object.getOwnPropertyDescriptor(t, "key").get;
        if (i && i.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function dt(t, i) {
      if (typeof t.ref == "string" && he.current && i && he.current.stateNode !== i) {
        var u = B(he.current.type);
        He[u] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(he.current.type), t.ref), He[u] = !0);
      }
    }
    function pt(t, i) {
      {
        var u = function() {
          Er || (Er = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function vt(t, i) {
      {
        var u = function() {
          gr || (gr = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var ht = function(t, i, u, h, R, A, _) {
      var g = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: i,
        ref: u,
        props: _,
        // Record the component responsible for creating this element.
        _owner: A
      };
      return g._store = {}, Object.defineProperty(g._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(g, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: h
      }), Object.defineProperty(g, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
    };
    function mt(t, i, u, h, R) {
      {
        var A, _ = {}, g = null, W = null;
        u !== void 0 && (yr(u), g = "" + u), lt(i) && (yr(i.key), g = "" + i.key), ft(i) && (W = i.ref, dt(i, R));
        for (A in i)
          $e.call(i, A) && !ut.hasOwnProperty(A) && (_[A] = i[A]);
        if (t && t.defaultProps) {
          var D = t.defaultProps;
          for (A in D)
            _[A] === void 0 && (_[A] = D[A]);
        }
        if (g || W) {
          var F = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          g && pt(_, F), W && vt(_, F);
        }
        return ht(t, g, W, R, h, he.current, _);
      }
    }
    var Ze = S.ReactCurrentOwner, br = S.ReactDebugCurrentFrame;
    function ae(t) {
      if (t) {
        var i = t._owner, u = ee(t.type, t._source, i ? i.type : null);
        br.setExtraStackFrame(u);
      } else
        br.setExtraStackFrame(null);
    }
    var Xe;
    Xe = !1;
    function Qe(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function _r() {
      {
        if (Ze.current) {
          var t = B(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function yt(t) {
      {
        if (t !== void 0) {
          var i = t.fileName.replace(/^.*[\\\/]/, ""), u = t.lineNumber;
          return `

Check your code at ` + i + ":" + u + ".";
        }
        return "";
      }
    }
    var Sr = {};
    function Et(t) {
      {
        var i = _r();
        if (!i) {
          var u = typeof t == "string" ? t : t.displayName || t.name;
          u && (i = `

Check the top-level render call using <` + u + ">.");
        }
        return i;
      }
    }
    function Rr(t, i) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var u = Et(i);
        if (Sr[u])
          return;
        Sr[u] = !0;
        var h = "";
        t && t._owner && t._owner !== Ze.current && (h = " It was passed a child from " + B(t._owner.type) + "."), ae(t), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, h), ae(null);
      }
    }
    function wr(t, i) {
      {
        if (typeof t != "object")
          return;
        if (Ke(t))
          for (var u = 0; u < t.length; u++) {
            var h = t[u];
            Qe(h) && Rr(h, i);
          }
        else if (Qe(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = M(t);
          if (typeof R == "function" && R !== t.entries)
            for (var A = R.call(t), _; !(_ = A.next()).done; )
              Qe(_.value) && Rr(_.value, i);
        }
      }
    }
    function gt(t) {
      {
        var i = t.type;
        if (i == null || typeof i == "string")
          return;
        var u;
        if (typeof i == "function")
          u = i.propTypes;
        else if (typeof i == "object" && (i.$$typeof === v || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        i.$$typeof === y))
          u = i.propTypes;
        else
          return;
        if (u) {
          var h = B(i);
          ot(u, t.props, "prop", h, t);
        } else if (i.PropTypes !== void 0 && !Xe) {
          Xe = !0;
          var R = B(i);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof i.getDefaultProps == "function" && !i.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function bt(t) {
      {
        for (var i = Object.keys(t.props), u = 0; u < i.length; u++) {
          var h = i[u];
          if (h !== "children" && h !== "key") {
            ae(t), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", h), ae(null);
            break;
          }
        }
        t.ref !== null && (ae(t), E("Invalid attribute `ref` supplied to `React.Fragment`."), ae(null));
      }
    }
    function xr(t, i, u, h, R, A) {
      {
        var _ = Ue(t);
        if (!_) {
          var g = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var W = yt(R);
          W ? g += W : g += _r();
          var D;
          t === null ? D = "null" : Ke(t) ? D = "array" : t !== void 0 && t.$$typeof === r ? (D = "<" + (B(t.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : D = typeof t, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", D, g);
        }
        var F = mt(t, i, u, R, A);
        if (F == null)
          return F;
        if (_) {
          var q = i.children;
          if (q !== void 0)
            if (h)
              if (Ke(q)) {
                for (var oe = 0; oe < q.length; oe++)
                  wr(q[oe], t);
                Object.freeze && Object.freeze(q);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wr(q, t);
        }
        return t === a ? bt(F) : gt(F), F;
      }
    }
    function _t(t, i, u) {
      return xr(t, i, u, !0);
    }
    function St(t, i, u) {
      return xr(t, i, u, !1);
    }
    var Rt = St, wt = _t;
    ye.Fragment = a, ye.jsx = Rt, ye.jsxs = wt;
  }()), ye;
}
process.env.NODE_ENV === "production" ? rr.exports = Nt() : rr.exports = At();
var Pr = rr.exports;
function $t(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function kt(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var It = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var s;
      a.tags.length === 0 ? a.insertionPoint ? s = a.insertionPoint.nextSibling : a.prepend ? s = a.container.firstChild : s = a.before : s = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, s), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(kt(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var s = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      s && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !s;
    }
    if (this.isSpeedy) {
      var f = $t(o);
      try {
        f.insertRule(a, f.cssRules.length);
      } catch (l) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', l);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), Y = "-ms-", je = "-moz-", w = "-webkit-", sr = "comm", cr = "rule", ur = "decl", Dt = "@import", Ur = "@keyframes", Mt = "@layer", Ft = Math.abs, Ve = String.fromCharCode, jt = Object.assign;
function Lt(e, r) {
  return V(e, 0) ^ 45 ? (((r << 2 ^ V(e, 0)) << 2 ^ V(e, 1)) << 2 ^ V(e, 2)) << 2 ^ V(e, 3) : 0;
}
function qr(e) {
  return e.trim();
}
function Vt(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function x(e, r, n) {
  return e.replace(r, n);
}
function tr(e, r) {
  return e.indexOf(r);
}
function V(e, r) {
  return e.charCodeAt(r) | 0;
}
function be(e, r, n) {
  return e.slice(r, n);
}
function J(e) {
  return e.length;
}
function fr(e) {
  return e.length;
}
function Ie(e, r) {
  return r.push(e), e;
}
function Yt(e, r) {
  return e.map(r).join("");
}
var Ye = 1, se = 1, Br = 0, z = 0, j = 0, ce = "";
function We(e, r, n, a, o, s, f) {
  return { value: e, root: r, parent: n, type: a, props: o, children: s, line: Ye, column: se, length: f, return: "" };
}
function Ee(e, r) {
  return jt(We("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Wt() {
  return j;
}
function zt() {
  return j = z > 0 ? V(ce, --z) : 0, se--, j === 10 && (se = 1, Ye--), j;
}
function U() {
  return j = z < Br ? V(ce, z++) : 0, se++, j === 10 && (se = 1, Ye++), j;
}
function K() {
  return V(ce, z);
}
function De() {
  return z;
}
function Re(e, r) {
  return be(ce, e, r);
}
function _e(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Gr(e) {
  return Ye = se = 1, Br = J(ce = e), z = 0, [];
}
function Jr(e) {
  return ce = "", e;
}
function Me(e) {
  return qr(Re(z - 1, nr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Ut(e) {
  for (; (j = K()) && j < 33; )
    U();
  return _e(e) > 2 || _e(j) > 3 ? "" : " ";
}
function qt(e, r) {
  for (; --r && U() && !(j < 48 || j > 102 || j > 57 && j < 65 || j > 70 && j < 97); )
    ;
  return Re(e, De() + (r < 6 && K() == 32 && U() == 32));
}
function nr(e) {
  for (; U(); )
    switch (j) {
      case e:
        return z;
      case 34:
      case 39:
        e !== 34 && e !== 39 && nr(j);
        break;
      case 40:
        e === 41 && nr(e);
        break;
      case 92:
        U();
        break;
    }
  return z;
}
function Bt(e, r) {
  for (; U() && e + j !== 47 + 10; )
    if (e + j === 42 + 42 && K() === 47)
      break;
  return "/*" + Re(r, z - 1) + "*" + Ve(e === 47 ? e : U());
}
function Gt(e) {
  for (; !_e(K()); )
    U();
  return Re(e, z);
}
function Jt(e) {
  return Jr(Fe("", null, null, null, [""], e = Gr(e), 0, [0], e));
}
function Fe(e, r, n, a, o, s, f, l, v) {
  for (var m = 0, d = 0, y = f, $ = 0, k = 0, N = 0, b = 1, M = 1, S = 1, E = 0, P = "", I = o, c = s, L = a, O = P; M; )
    switch (N = E, E = U()) {
      case 40:
        if (N != 108 && V(O, y - 1) == 58) {
          tr(O += x(Me(E), "&", "&\f"), "&\f") != -1 && (S = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        O += Me(E);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        O += Ut(N);
        break;
      case 92:
        O += qt(De() - 1, 7);
        continue;
      case 47:
        switch (K()) {
          case 42:
          case 47:
            Ie(Kt(Bt(U(), De()), r, n), v);
            break;
          default:
            O += "/";
        }
        break;
      case 123 * b:
        l[m++] = J(O) * S;
      case 125 * b:
      case 59:
      case 0:
        switch (E) {
          case 0:
          case 125:
            M = 0;
          case 59 + d:
            S == -1 && (O = x(O, /\f/g, "")), k > 0 && J(O) - y && Ie(k > 32 ? Ar(O + ";", a, n, y - 1) : Ar(x(O, " ", "") + ";", a, n, y - 2), v);
            break;
          case 59:
            O += ";";
          default:
            if (Ie(L = Nr(O, r, n, m, d, o, l, P, I = [], c = [], y), s), E === 123)
              if (d === 0)
                Fe(O, r, L, L, I, s, y, l, c);
              else
                switch ($ === 99 && V(O, 3) === 110 ? 100 : $) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Fe(e, L, L, a && Ie(Nr(e, L, L, 0, 0, o, l, P, o, I = [], y), c), o, c, y, l, a ? I : c);
                    break;
                  default:
                    Fe(O, L, L, L, [""], c, 0, l, c);
                }
        }
        m = d = k = 0, b = S = 1, P = O = "", y = f;
        break;
      case 58:
        y = 1 + J(O), k = N;
      default:
        if (b < 1) {
          if (E == 123)
            --b;
          else if (E == 125 && b++ == 0 && zt() == 125)
            continue;
        }
        switch (O += Ve(E), E * b) {
          case 38:
            S = d > 0 ? 1 : (O += "\f", -1);
            break;
          case 44:
            l[m++] = (J(O) - 1) * S, S = 1;
            break;
          case 64:
            K() === 45 && (O += Me(U())), $ = K(), d = y = J(P = O += Gt(De())), E++;
            break;
          case 45:
            N === 45 && J(O) == 2 && (b = 0);
        }
    }
  return s;
}
function Nr(e, r, n, a, o, s, f, l, v, m, d) {
  for (var y = o - 1, $ = o === 0 ? s : [""], k = fr($), N = 0, b = 0, M = 0; N < a; ++N)
    for (var S = 0, E = be(e, y + 1, y = Ft(b = f[N])), P = e; S < k; ++S)
      (P = qr(b > 0 ? $[S] + " " + E : x(E, /&\f/g, $[S]))) && (v[M++] = P);
  return We(e, r, n, o === 0 ? cr : l, v, m, d);
}
function Kt(e, r, n) {
  return We(e, r, n, sr, Ve(Wt()), be(e, 2, -2), 0);
}
function Ar(e, r, n, a) {
  return We(e, r, n, ur, be(e, 0, a), be(e, a + 1, -1), a);
}
function ie(e, r) {
  for (var n = "", a = fr(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function Ht(e, r, n, a) {
  switch (e.type) {
    case Mt:
      if (e.children.length)
        break;
    case Dt:
    case ur:
      return e.return = e.return || e.value;
    case sr:
      return "";
    case Ur:
      return e.return = e.value + "{" + ie(e.children, a) + "}";
    case cr:
      e.value = e.props.join(",");
  }
  return J(n = ie(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function Zt(e) {
  var r = fr(e);
  return function(n, a, o, s) {
    for (var f = "", l = 0; l < r; l++)
      f += e[l](n, a, o, s) || "";
    return f;
  };
}
function Xt(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function Qt(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var en = function(r, n, a) {
  for (var o = 0, s = 0; o = s, s = K(), o === 38 && s === 12 && (n[a] = 1), !_e(s); )
    U();
  return Re(r, z);
}, rn = function(r, n) {
  var a = -1, o = 44;
  do
    switch (_e(o)) {
      case 0:
        o === 38 && K() === 12 && (n[a] = 1), r[a] += en(z - 1, n, a);
        break;
      case 2:
        r[a] += Me(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = K() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += Ve(o);
    }
  while (o = U());
  return r;
}, tn = function(r, n) {
  return Jr(rn(Gr(r), n));
}, $r = /* @__PURE__ */ new WeakMap(), nn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !$r.get(a)) && !o) {
      $r.set(r, !0);
      for (var s = [], f = tn(n, s), l = a.props, v = 0, m = 0; v < f.length; v++)
        for (var d = 0; d < l.length; d++, m++)
          r.props[m] = s[v] ? f[v].replace(/&\f/g, l[d]) : l[d] + " " + f[v];
    }
  }
}, an = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, on = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", sn = function(r) {
  return r.type === "comm" && r.children.indexOf(on) > -1;
}, cn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var s = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (s) {
        for (var f = !!n.parent, l = f ? n.parent.children : (
          // global rule at the root level
          o
        ), v = l.length - 1; v >= 0; v--) {
          var m = l[v];
          if (m.line < n.line)
            break;
          if (m.column < n.column) {
            if (sn(m))
              return;
            break;
          }
        }
        s.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, Kr = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, un = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!Kr(n[a]))
      return !0;
  return !1;
}, kr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, fn = function(r, n, a) {
  Kr(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), kr(r)) : un(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), kr(r)));
};
function Hr(e, r) {
  switch (Lt(e, r)) {
    case 5103:
      return w + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return w + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return w + e + je + e + Y + e + e;
    case 6828:
    case 4268:
      return w + e + Y + e + e;
    case 6165:
      return w + e + Y + "flex-" + e + e;
    case 5187:
      return w + e + x(e, /(\w+).+(:[^]+)/, w + "box-$1$2" + Y + "flex-$1$2") + e;
    case 5443:
      return w + e + Y + "flex-item-" + x(e, /flex-|-self/, "") + e;
    case 4675:
      return w + e + Y + "flex-line-pack" + x(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return w + e + Y + x(e, "shrink", "negative") + e;
    case 5292:
      return w + e + Y + x(e, "basis", "preferred-size") + e;
    case 6060:
      return w + "box-" + x(e, "-grow", "") + w + e + Y + x(e, "grow", "positive") + e;
    case 4554:
      return w + x(e, /([^-])(transform)/g, "$1" + w + "$2") + e;
    case 6187:
      return x(x(x(e, /(zoom-|grab)/, w + "$1"), /(image-set)/, w + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return x(e, /(image-set\([^]*)/, w + "$1$`$1");
    case 4968:
      return x(x(e, /(.+:)(flex-)?(.*)/, w + "box-pack:$3" + Y + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + w + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return x(e, /(.+)-inline(.+)/, w + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (J(e) - 1 - r > 6)
        switch (V(e, r + 1)) {
          case 109:
            if (V(e, r + 4) !== 45)
              break;
          case 102:
            return x(e, /(.+:)(.+)-([^]+)/, "$1" + w + "$2-$3$1" + je + (V(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~tr(e, "stretch") ? Hr(x(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (V(e, r + 1) !== 115)
        break;
    case 6444:
      switch (V(e, J(e) - 3 - (~tr(e, "!important") && 10))) {
        case 107:
          return x(e, ":", ":" + w) + e;
        case 101:
          return x(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + w + (V(e, 14) === 45 ? "inline-" : "") + "box$3$1" + w + "$2$3$1" + Y + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (V(e, r + 11)) {
        case 114:
          return w + e + Y + x(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return w + e + Y + x(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return w + e + Y + x(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return w + e + Y + e + e;
  }
  return e;
}
var ln = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case ur:
        r.return = Hr(r.value, r.length);
        break;
      case Ur:
        return ie([Ee(r, {
          value: x(r.value, "@", "@" + w)
        })], o);
      case cr:
        if (r.length)
          return Yt(r.props, function(s) {
            switch (Vt(s, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ie([Ee(r, {
                  props: [x(s, /:(read-\w+)/, ":" + je + "$1")]
                })], o);
              case "::placeholder":
                return ie([Ee(r, {
                  props: [x(s, /:(plac\w+)/, ":" + w + "input-$1")]
                }), Ee(r, {
                  props: [x(s, /:(plac\w+)/, ":" + je + "$1")]
                }), Ee(r, {
                  props: [x(s, /:(plac\w+)/, Y + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, dn = [ln], pn = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(b) {
      var M = b.getAttribute("data-emotion");
      M.indexOf(" ") !== -1 && (document.head.appendChild(b), b.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || dn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var s = {}, f, l = [];
  f = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(b) {
      for (var M = b.getAttribute("data-emotion").split(" "), S = 1; S < M.length; S++)
        s[M[S]] = !0;
      l.push(b);
    }
  );
  var v, m = [nn, an];
  process.env.NODE_ENV !== "production" && m.push(cn({
    get compat() {
      return N.compat;
    }
  }), fn);
  {
    var d, y = [Ht, process.env.NODE_ENV !== "production" ? function(b) {
      b.root || (b.return ? d.insert(b.return) : b.value && b.type !== sr && d.insert(b.value + "{}"));
    } : Xt(function(b) {
      d.insert(b);
    })], $ = Zt(m.concat(o, y)), k = function(M) {
      return ie(Jt(M), $);
    };
    v = function(M, S, E, P) {
      d = E, process.env.NODE_ENV !== "production" && S.map !== void 0 && (d = {
        insert: function(c) {
          E.insert(c + S.map);
        }
      }), k(M ? M + "{" + S.styles + "}" : S.styles), P && (N.inserted[S.name] = !0);
    };
  }
  var N = {
    key: n,
    sheet: new It({
      key: n,
      container: f,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: s,
    registered: {},
    insert: v
  };
  return N.sheet.hydrate(l), N;
}, ar = { exports: {} }, C = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ir;
function vn() {
  if (Ir)
    return C;
  Ir = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, v = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, $ = e ? Symbol.for("react.suspense_list") : 60120, k = e ? Symbol.for("react.memo") : 60115, N = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, M = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function P(c) {
    if (typeof c == "object" && c !== null) {
      var L = c.$$typeof;
      switch (L) {
        case r:
          switch (c = c.type, c) {
            case v:
            case m:
            case a:
            case s:
            case o:
            case y:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case l:
                case d:
                case N:
                case k:
                case f:
                  return c;
                default:
                  return L;
              }
          }
        case n:
          return L;
      }
    }
  }
  function I(c) {
    return P(c) === m;
  }
  return C.AsyncMode = v, C.ConcurrentMode = m, C.ContextConsumer = l, C.ContextProvider = f, C.Element = r, C.ForwardRef = d, C.Fragment = a, C.Lazy = N, C.Memo = k, C.Portal = n, C.Profiler = s, C.StrictMode = o, C.Suspense = y, C.isAsyncMode = function(c) {
    return I(c) || P(c) === v;
  }, C.isConcurrentMode = I, C.isContextConsumer = function(c) {
    return P(c) === l;
  }, C.isContextProvider = function(c) {
    return P(c) === f;
  }, C.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, C.isForwardRef = function(c) {
    return P(c) === d;
  }, C.isFragment = function(c) {
    return P(c) === a;
  }, C.isLazy = function(c) {
    return P(c) === N;
  }, C.isMemo = function(c) {
    return P(c) === k;
  }, C.isPortal = function(c) {
    return P(c) === n;
  }, C.isProfiler = function(c) {
    return P(c) === s;
  }, C.isStrictMode = function(c) {
    return P(c) === o;
  }, C.isSuspense = function(c) {
    return P(c) === y;
  }, C.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === m || c === s || c === o || c === y || c === $ || typeof c == "object" && c !== null && (c.$$typeof === N || c.$$typeof === k || c.$$typeof === f || c.$$typeof === l || c.$$typeof === d || c.$$typeof === M || c.$$typeof === S || c.$$typeof === E || c.$$typeof === b);
  }, C.typeOf = P, C;
}
var T = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dr;
function hn() {
  return Dr || (Dr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, v = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, $ = e ? Symbol.for("react.suspense_list") : 60120, k = e ? Symbol.for("react.memo") : 60115, N = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, M = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function P(p) {
      return typeof p == "string" || typeof p == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      p === a || p === m || p === s || p === o || p === y || p === $ || typeof p == "object" && p !== null && (p.$$typeof === N || p.$$typeof === k || p.$$typeof === f || p.$$typeof === l || p.$$typeof === d || p.$$typeof === M || p.$$typeof === S || p.$$typeof === E || p.$$typeof === b);
    }
    function I(p) {
      if (typeof p == "object" && p !== null) {
        var ve = p.$$typeof;
        switch (ve) {
          case r:
            var ne = p.type;
            switch (ne) {
              case v:
              case m:
              case a:
              case s:
              case o:
              case y:
                return ne;
              default:
                var ee = ne && ne.$$typeof;
                switch (ee) {
                  case l:
                  case d:
                  case N:
                  case k:
                  case f:
                    return ee;
                  default:
                    return ve;
                }
            }
          case n:
            return ve;
        }
      }
    }
    var c = v, L = m, O = l, ze = f, we = r, Ue = d, qe = a, xe = N, B = k, H = n, Q = s, Ce = o, Te = y, ue = !1;
    function Oe(p) {
      return ue || (ue = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), fe(p) || I(p) === v;
    }
    function fe(p) {
      return I(p) === m;
    }
    function Pe(p) {
      return I(p) === l;
    }
    function Ne(p) {
      return I(p) === f;
    }
    function Ae(p) {
      return typeof p == "object" && p !== null && p.$$typeof === r;
    }
    function Be(p) {
      return I(p) === d;
    }
    function Ge(p) {
      return I(p) === a;
    }
    function le(p) {
      return I(p) === N;
    }
    function de(p) {
      return I(p) === k;
    }
    function re(p) {
      return I(p) === n;
    }
    function pe(p) {
      return I(p) === s;
    }
    function te(p) {
      return I(p) === o;
    }
    function Je(p) {
      return I(p) === y;
    }
    T.AsyncMode = c, T.ConcurrentMode = L, T.ContextConsumer = O, T.ContextProvider = ze, T.Element = we, T.ForwardRef = Ue, T.Fragment = qe, T.Lazy = xe, T.Memo = B, T.Portal = H, T.Profiler = Q, T.StrictMode = Ce, T.Suspense = Te, T.isAsyncMode = Oe, T.isConcurrentMode = fe, T.isContextConsumer = Pe, T.isContextProvider = Ne, T.isElement = Ae, T.isForwardRef = Be, T.isFragment = Ge, T.isLazy = le, T.isMemo = de, T.isPortal = re, T.isProfiler = pe, T.isStrictMode = te, T.isSuspense = Je, T.isValidElementType = P, T.typeOf = I;
  }()), T;
}
process.env.NODE_ENV === "production" ? ar.exports = vn() : ar.exports = hn();
var mn = ar.exports, Zr = mn, yn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, En = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Xr = {};
Xr[Zr.ForwardRef] = yn;
Xr[Zr.Memo] = En;
var gn = !0;
function bn(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var Qr = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  gn === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, _n = function(r, n, a) {
  Qr(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var s = n;
    do
      r.insert(n === s ? "." + o : "", s, r.sheet, !0), s = s.next;
    while (s !== void 0);
  }
};
function Sn(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var Rn = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Mr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, wn = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", xn = /[A-Z]|^ms/g, et = /_EMO_([^_]+?)_([^]*?)_EMO_/g, lr = function(r) {
  return r.charCodeAt(1) === 45;
}, Fr = function(r) {
  return r != null && typeof r != "boolean";
}, er = /* @__PURE__ */ Qt(function(e) {
  return lr(e) ? e : e.replace(xn, "-$&").toLowerCase();
}), Le = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(et, function(a, o, s) {
          return G = {
            name: o,
            styles: s,
            next: G
          }, o;
        });
  }
  return Rn[r] !== 1 && !lr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var Cn = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Tn = ["normal", "none", "initial", "inherit", "unset"], On = Le, Pn = /^-ms-/, Nn = /-(.)/g, jr = {};
  Le = function(r, n) {
    if (r === "content" && (typeof n != "string" || Tn.indexOf(n) === -1 && !Cn.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = On(r, n);
    return a !== "" && !lr(r) && r.indexOf("-") !== -1 && jr[r] === void 0 && (jr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Pn, "ms-").replace(Nn, function(o, s) {
      return s.toUpperCase();
    }) + "?")), a;
  };
}
var rt = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Se(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(rt);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return G = {
          name: n.name,
          styles: n.styles,
          next: G
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            G = {
              name: a.name,
              styles: a.styles,
              next: G
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return An(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var s = G, f = n(e);
        return G = s, Se(e, r, f);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var l = [], v = n.replace(et, function(d, y, $) {
          var k = "animation" + l.length;
          return l.push("const " + k + " = keyframes`" + $.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + k + "}";
        });
        l.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(l, ["`" + v + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + v + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var m = r[n];
  return m !== void 0 ? m : n;
}
function An(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += Se(e, r, n[o]) + ";";
  else
    for (var s in n) {
      var f = n[s];
      if (typeof f != "object")
        r != null && r[f] !== void 0 ? a += s + "{" + r[f] + "}" : Fr(f) && (a += er(s) + ":" + Le(s, f) + ";");
      else {
        if (s === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(rt);
        if (Array.isArray(f) && typeof f[0] == "string" && (r == null || r[f[0]] === void 0))
          for (var l = 0; l < f.length; l++)
            Fr(f[l]) && (a += er(s) + ":" + Le(s, f[l]) + ";");
        else {
          var v = Se(e, r, f);
          switch (s) {
            case "animation":
            case "animationName": {
              a += er(s) + ":" + v + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && s === "undefined" && console.error(wn), a += s + "{" + v + "}";
          }
        }
      }
    }
  return a;
}
var Lr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, tt;
process.env.NODE_ENV !== "production" && (tt = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var G, Vr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, s = "";
  G = void 0;
  var f = r[0];
  f == null || f.raw === void 0 ? (o = !1, s += Se(a, n, f)) : (process.env.NODE_ENV !== "production" && f[0] === void 0 && console.error(Mr), s += f[0]);
  for (var l = 1; l < r.length; l++)
    s += Se(a, n, r[l]), o && (process.env.NODE_ENV !== "production" && f[l] === void 0 && console.error(Mr), s += f[l]);
  var v;
  process.env.NODE_ENV !== "production" && (s = s.replace(tt, function($) {
    return v = $, "";
  })), Lr.lastIndex = 0;
  for (var m = "", d; (d = Lr.exec(s)) !== null; )
    m += "-" + // $FlowFixMe we know it's not null
    d[1];
  var y = Sn(s) + m;
  return process.env.NODE_ENV !== "production" ? {
    name: y,
    styles: s,
    map: v,
    next: G,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: y,
    styles: s,
    next: G
  };
}, $n = function(r) {
  return r();
}, kn = X["useInsertionEffect"] ? X["useInsertionEffect"] : !1, In = kn || $n, dr = {}.hasOwnProperty, pr = /* @__PURE__ */ X.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ pn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (pr.displayName = "EmotionCacheContext");
pr.Provider;
var Dn = function(r) {
  return /* @__PURE__ */ zr(function(n, a) {
    var o = xt(pr);
    return r(n, o, a);
  });
}, nt = /* @__PURE__ */ X.createContext({});
process.env.NODE_ENV !== "production" && (nt.displayName = "EmotionThemeContext");
var Yr = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, Mn = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return Yr(n[1]);
}, Fn = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), jn = function(r) {
  return r.replace(/\$/g, "-");
}, Ln = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = Mn(n[a]);
      if (o) {
        if (Fn.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return jn(o);
      }
    }
}, or = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", ir = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", Vn = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    dr.call(n, o) && (a[o] = n[o]);
  if (a[or] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var s = Ln(new Error().stack);
    s && (a[ir] = s);
  }
  return a;
}, Yn = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return Qr(n, a, o), In(function() {
    return _n(n, a, o);
  }), null;
}, at = /* @__PURE__ */ Dn(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[or], s = [a], f = "";
  typeof e.className == "string" ? f = bn(r.registered, s, e.className) : e.className != null && (f = e.className + " ");
  var l = Vr(s, void 0, X.useContext(nt));
  if (process.env.NODE_ENV !== "production" && l.name.indexOf("-") === -1) {
    var v = e[ir];
    v && (l = Vr([l, "label:" + v + ";"]));
  }
  f += r.key + "-" + l.name;
  var m = {};
  for (var d in e)
    dr.call(e, d) && d !== "css" && d !== or && (process.env.NODE_ENV === "production" || d !== ir) && (m[d] = e[d]);
  return m.ref = n, m.className = f, /* @__PURE__ */ X.createElement(X.Fragment, null, /* @__PURE__ */ X.createElement(Yn, {
    cache: r,
    serialized: l,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ X.createElement(o, m));
});
process.env.NODE_ENV !== "production" && (at.displayName = "EmotionCssPropInternal");
var Wn = at;
function zn(e, r, n) {
  return dr.call(r, "css") ? Pr.jsx(Wn, Vn(e, r), n) : Pr.jsx(e, r, n);
}
const Un = Ct`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
function qn(e, r) {
  let n;
  n = Tt(e, "01");
  let a;
  switch (r) {
    case "small":
      a = ge`
        width: 12px;
        height: 12px;
      `;
      break;
    case "large":
      a = ge`
        width: 24px;
        height: 24px;
      `;
      break;
    default:
      a = ge`
        width: 16px;
        height: 16px;
      `;
  }
  return ge`
    display: inline-block;
    ${a};
    border-radius: 50%;
    background: conic-gradient(
      rgba(101, 74, 236, 0) 45deg,
      rgba(101, 74, 236, 0) 80deg,
      ${n} 30deg,
      rgba(101, 74, 236, 0)
    );
    mask-image: radial-gradient(closest-side, transparent 75%, black 76%);
    animation: ${Un} 1s linear infinite reverse;
  `;
}
const Bn = zr((e, r) => {
  const { colorScheme: n = "gray", size: a = "medium", ...o } = e;
  return zn("div", { ref: r, css: ge(qn(n, a), Ot(e)), ...Pt(o) });
});
Bn.displayName = "Loading";
export {
  Bn as Loading,
  qn as applyLoadingStyle,
  Un as spin
};
//# sourceMappingURL=index.js.map
